import React from 'react';
import { initializeApp, getApps } from 'firebase/app';
import StatsigProvider from './src/components/StatsigProvider';
import environment from './src/constants/environment';

export const onClientEntry = () => {
  // Initialize Firebase before React hydrates
  if (typeof window !== 'undefined' && getApps().length === 0) {
    initializeApp({
      apiKey: environment.apiKey,
      authDomain: environment.authDomain,
      databaseURL: environment.databaseURL,
      projectId: environment.projectId,
      storageBucket: environment.storageBucket,
      messagingSenderId: environment.messagingSenderId,
    });
  }
};

export const onInitialClientRender = () => {
  // Initialize Mixpanel after React hydrates
  if (typeof window !== 'undefined' && window.mixpanel && window.mixpanel.init) {
    window.mixpanel.init(environment.mixpanelKey, {
      track_page_view: false,
    });
  }
};

export const wrapRootElement = ({ element }) => {
  return <StatsigProvider>{element}</StatsigProvider>;
};
